import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { OrderExceptionsPageRoutingModule } from './order-exceptions-routing.module';

import { OrderExceptionsPage } from './order-exceptions.page';
import { ExceptionProductBaseComponent } from '../../components/order-exceptions/substitution-row/product/exception-product-base.component';
import { ExceptionProductDesktopComponent } from '../../components/order-exceptions/substitution-row/product/desktop/order-exception-product-desktop/exception-product-desktop.component';
import { ExceptionProductTabletComponent } from '../../components/order-exceptions/substitution-row/product/tablet/order-exception-product-tablet/exception-product-tablet.component';
import { ExceptionProductMobileComponent } from '../../components/order-exceptions/substitution-row/product/mobile/order-exception-product-mobile/exception-product-mobile.component';
import { ExceptionSectionBaseComponent } from '../../components/order-exceptions/expandable-section/exception-section-base.component';
import { ExceptionSectionTabletComponent } from '../../components/order-exceptions/expandable-section/tablet/order-exception-product-section-tablet/exception-section-tablet.component';
import { ExceptionSectionMobileComponent } from '../../components/order-exceptions/expandable-section/mobile/order-exception-product-section-mobile/exception-section-mobile.component';
import { ExceptionSectionDesktopComponent } from '../../components/order-exceptions/expandable-section/desktop/exception-section-desktop.component';
import { SubstitutionRowBaseComponent } from '../../components/order-exceptions/substitution-row/substitution-row-base.component';
import { SubstitutionRowDesktopComponent } from '../../components/order-exceptions/substitution-row/desktop/substitution-row-desktop/substitution-row-desktop.component';
import { SubstitutionRowMobileComponent } from '../../components/order-exceptions/substitution-row/mobile/substitution-row-mobile/substitution-row-mobile.component';
import { SubstitutionRowTabletComponent } from '../../components/order-exceptions/substitution-row/tablet/substitution-row-tablet/substitution-row-tablet.component';
import { AcknowledgementRowDesktopComponent } from '../../components/order-exceptions/acknowledgement-row/desktop/acknowledgement-row-desktop/acknowledgement-row-desktop.component';
import { AcknowledgementRowBaseComponent } from '../../components/order-exceptions/acknowledgement-row/acknowledgement-row-base.component';
import { AcknowledgementRowMobileComponent } from '../../components/order-exceptions/acknowledgement-row/mobile/acknowledgement-row-mobile/acknowledgement-row-mobile.component';
import { AcknowledgementRowTabletComponent } from '../../components/order-exceptions/acknowledgement-row/tablet/acknowledgement-row-tablet/acknowledgement-row-tablet.component';
import { SharedModule } from '../../../shared/shared.module';
import { FlipsideProductBaseComponent } from '../../components/order-exceptions/substitution-row/flipside-product/flipside-product-base.component';
import { FlipsideProductDesktopComponent } from '../../components/order-exceptions/substitution-row/flipside-product/desktop/flipside-product-desktop/flipside-product-desktop.component';
import { FlipsideProductMobileComponent } from '../../components/order-exceptions/substitution-row/flipside-product/mobile/flipside-product-mobile/flipside-product-mobile.component';
import { FlipsideProductTabletComponent } from '../../components/order-exceptions/substitution-row/flipside-product/tablet/flipside-product-tablet/flipside-product-tablet.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { httpLoaderFactory } from '../../../app.module';
import { HttpClient } from '@angular/common/http';
import { UnusualQuantityRowBaseComponent } from '../../components/order-exceptions/unusual-quantity-row/unusual-quantity-row-base.component';
import { UnusualQuantityRowDesktopComponent } from '../../components/order-exceptions/unusual-quantity-row/desktop/unusual-quantity-row-desktop/unusual-quantity-row-desktop.component';
import { UnusualQuantityRowMobileComponent } from '../../components/order-exceptions/unusual-quantity-row/mobile/unusual-quantity-row-mobile/unusual-quantity-row-mobile.component';
import { UnusualQuantityRowTabletComponent } from '../../components/order-exceptions/unusual-quantity-row/tablet/unusual-quantity-row-tablet/unusual-quantity-row-tablet.component';
import { EffectsModule } from '@ngrx/effects';
import { ClientOrderExceptionEffects } from './effects/client-order-exception.effects';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { PricingRowDesktopComponent } from '../../components/order-exceptions/pricing-row/desktop/pricing-row-desktop/pricing-row-desktop.component';
import { PricingRowTabletComponent } from '../../components/order-exceptions/pricing-row/tablet/pricing-row-tablet/pricing-row-tablet.component';
import { PricingRowMobileComponent } from '../../components/order-exceptions/pricing-row/mobile/pricing-row-mobile/pricing-row-mobile.component';
import { PricingRowBaseComponent } from '../../components/order-exceptions/pricing-row/pricing-row-base.component';
import { DateRowBaseComponent } from '../../components/order-exceptions/date-row/date-row-base.component';
import { DateRowDesktopComponent } from '../../components/order-exceptions/date-row/desktop/date-row-desktop/date-row-desktop.component';
import { DateRowTabletComponent } from '../../components/order-exceptions/date-row/tablet/date-row-tablet/date-row-tablet.component';
import { DateRowMobileComponent } from '../../components/order-exceptions/date-row/mobile/date-row-mobile/date-row-mobile.component';
import { DateExceptionCalendarComponent } from '../../components/order-exceptions/date-exception-calendar/date-exception-calendar.component';
import { ClientNonVisualPunchThruEffects } from '@shared/effects/non-visual-punchthru/non-visual-punchthru.effects';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule.forRoot({
      mode: 'ios',
      scrollAssist: true,
      scrollPadding: true,
    }),
    OrderExceptionsPageRoutingModule,
    SharedModule,
    MatRadioModule,
    MatCardModule,
    ReactiveFormsModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    EffectsModule.forFeature([
      ClientOrderExceptionEffects,
      ClientNonVisualPunchThruEffects,
    ]),
  ],
  declarations: [
    OrderExceptionsPage,
    ExceptionProductBaseComponent,
    ExceptionProductDesktopComponent,
    ExceptionProductTabletComponent,
    ExceptionProductMobileComponent,
    ExceptionSectionBaseComponent,
    ExceptionSectionTabletComponent,
    ExceptionSectionMobileComponent,
    ExceptionSectionDesktopComponent,
    SubstitutionRowBaseComponent,
    SubstitutionRowDesktopComponent,
    SubstitutionRowMobileComponent,
    SubstitutionRowTabletComponent,
    AcknowledgementRowDesktopComponent,
    AcknowledgementRowMobileComponent,
    AcknowledgementRowTabletComponent,
    AcknowledgementRowBaseComponent,
    FlipsideProductBaseComponent,
    FlipsideProductDesktopComponent,
    FlipsideProductMobileComponent,
    FlipsideProductTabletComponent,
    UnusualQuantityRowBaseComponent,
    UnusualQuantityRowDesktopComponent,
    UnusualQuantityRowMobileComponent,
    UnusualQuantityRowTabletComponent,
    PricingRowDesktopComponent,
    PricingRowTabletComponent,
    PricingRowMobileComponent,
    PricingRowBaseComponent,
    DateRowBaseComponent,
    DateRowDesktopComponent,
    DateRowTabletComponent,
    DateRowMobileComponent,
    DateExceptionCalendarComponent,
  ],
})
export class OrderExceptionsPageModule {}
